import React from 'react';
import { FeatureFlagActiveSwitch } from './FeatureFlagActiveSwitch';
import { FeatureFlagTargetsCell } from './FeatureFlagTargetsCell';
import DataGridMultilinePopper from '@/components/table/DataGridComponents/DataGridMultilinePopper';
import { validateDescriptionCell } from '../descriptionValidationSchema';

const targetsFields = {
	flex: 1.5,
	minWidth: 220,
	sortable: false,
	display: 'flex',
};

/**
 * Columns for the admin feature flags list (sorted in the browser). Description is edited
 * in the cell: double-click or Enter opens a multi-line box; it can't be saved empty.
 */
export const featureFlagColumns = [
	{
		field: 'feature',
		headerName: 'Feature',
		flex: 1,
		minWidth: 200,
		hideable: false,
	},
	{
		field: 'description',
		headerName: 'Description',
		flex: 2,
		minWidth: 240,
		sortable: false,
		editable: true,
		hideable: false,
		preProcessEditCellProps: validateDescriptionCell,
		renderEditCell: (params) => <DataGridMultilinePopper {...params} rows={4} />,
	},
	{
		field: 'active',
		headerName: 'On for everyone',
		width: 150,
		display: 'flex',
		renderCell: ({ row }) => <FeatureFlagActiveSwitch flag={row} />,
	},
	{
		...targetsFields,
		field: 'users',
		headerName: 'Users',
		renderCell: ({ row }) => <FeatureFlagTargetsCell flag={row} field={'users'} />,
	},
	{
		...targetsFields,
		field: 'brokerGroups',
		headerName: 'Broker groups',
		renderCell: ({ row }) => <FeatureFlagTargetsCell flag={row} field={'brokerGroups'} />,
	},
	{
		...targetsFields,
		field: 'ledgers',
		headerName: 'Ledgers',
		renderCell: ({ row }) => <FeatureFlagTargetsCell flag={row} field={'ledgers'} />,
	},
];
